const fallbackRandomPart = (): string => {
  const cryptoApi = globalThis.crypto;
  if (cryptoApi && typeof cryptoApi.getRandomValues === 'function') {
    const bytes = new Uint8Array(8);
    cryptoApi.getRandomValues(bytes);
    return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }

  return Math.random().toString(36).slice(2);
};

export const createClientId = (prefix?: string): string => {
  const cryptoApi = globalThis.crypto;
  const randomUuid = cryptoApi && typeof cryptoApi.randomUUID === 'function'
    ? cryptoApi.randomUUID()
    : `${Date.now().toString(36)}-${fallbackRandomPart()}`;

  return prefix ? `${prefix}-${randomUuid}` : randomUuid;
};
